export const HeadingText = ({ children }) => {
    return children ? (
        <div className="text-sm text-gray-600 py-2">{children}</div>
    ) : null
}
